// table公用的一些方法

//#region 合并列

/**
 * 合并列使用方法
 * 其中 res 为需要展示的数据 ，dataArr1 ，rowSpanArr1用于合并列的中间数值
      dataArr1: [[]],
      rowSpanArr1: [[]] 
 * 1、import {toArray,getRowSpan,objectSpanMethod} from 'table.common.js'
 * 2、 that.dataArr1 = toArray(res, columns, propName) //columns 为列数据,例[{ prop:'ID',name:'编号'}, { prop:'name',name:'名称'}],propName 是指columns中列名所在的键值prop
 * 3、 that.rowSpanArr1 = getRowSpan(that.dataArr1)
 * 4、 创建一个方法如 
 * mergeSpanMethod({ row, column, rowIndex, columnIndex }) {
      return objectSpanMethod(
        { row, column, rowIndex, columnIndex },
        this.rowSpanArr1,
        [0, 1, 2, 3]
      )}
      在table上绑定 
       <myTable
            :data="table1"
            :showPage="false"
            :height="'calc(100vh - 240px)'"
            :arraySpanMethod="mergeSpanMethod"
          ></myTable>
 */

/**
 * 用于合并列
 * 用于把展示的数据给转换成datatable类型
 * @param {*} arr 数据源
 * @param {*} columns 列信息 例[{ prop:'ID',name:'编号'}, { prop:'name',name:'名称'}]
 * @param {*} propName propName 是指columns中列名所在的键值prop
 * @param {*} isNeedSelect 是否包含选择列
 * @returns
 */
export function toArray(arr, columns, propName, isNeedSelect) {
  var arrs = [[]]
  arr.forEach(function (v, i, arr) {
    // var keys = Object.keys(v)
    arrs[i] = new Array()
    if (isNeedSelect) {
      arrs[i][0] = ''
    }
    columns.forEach(function (v1) {
      arrs[i].push(arr[i][v1[propName]]) //用于把展示的数据给转换成datatable类型，
    })
  })
  return arrs
}

/*** 用于合并列
 * 列合并数组数据（记录每个单元格占用多少行，rowposition为当前计算行）
 */
export function getRowSpan(dataArr) {
  var rowSpanArr = [[]]
  let columns = dataArr[0].length || 0
  //用于记录每列的计算行
  let rowposition = Array(columns).fill(0)
  dataArr.forEach((item, row) => {
    //初始化每行每列
    rowSpanArr[row] = Array(columns).fill(1)
    if (row > 0) {
      //循环列
      let over = false
      for (let column = 0; column < dataArr[row].length; column++) {
        if (dataArr[row][column] == dataArr[row - 1][column]) {
          if (over) {
            rowposition[column] = row
          } else {
            rowSpanArr[rowposition[column]][column] += 1
            rowSpanArr[row][column] = 0
          }
        } else {
          rowposition[column] = row
          over = true
        }
      }
    }
  })
  return rowSpanArr
}

/**
 * 用于合并列，当前列根据其他列是否相等进行合并
 * @param {*} dataArr
 * @param {*} condition [{colmunIndex:0,condition:['prop1','prop2','prop3']}] 表示第0列是根据数据中的 prop1,prop2,prop3三个字段进行行合并
 * @returns
 */
export function getRowSpanForCondition(data, dataArr, conditions) {
  var rowSpanArr = [[]]
  let columns = dataArr[0].length || 0
  //用于记录每列的计算行
  let rowposition = Array(columns).fill(0)
  //循环每一行数据
  dataArr.forEach((item, row) => {
    //初始化每行每列
    rowSpanArr[row] = Array(columns).fill(1)
    if (row > 0) {
      let over = false //判断当前行是否重新开始合并
      //循环当前行的每一列
      for (let column = 0; column < dataArr[row].length; column++) {
        let flag = conditions.find((m) => {
          return m.colmunIndex == column
        })
        let isMerge = true
        if (flag) {
          //根据条件进行合并
          flag.condition.forEach((x) => {
            let current = data[row][x] || ''
            let last = data[row - 1][x] || ''
            if (current != last) {
              isMerge = false
            }
          })
        }
        // 只根据本列进行合并
        if (isMerge && dataArr[row][column] == dataArr[row - 1][column]) {
          if (over) {
            rowposition[column] = row
          } else {
            rowSpanArr[rowposition[column]][column] += 1
            rowSpanArr[row][column] = 0
          }
        } else {
          rowposition[column] = row
          over = true
        }
      }
    }
  })
  return rowSpanArr
}

/***
 * 合并列的方法
 * { row, column, rowIndex, columnIndex }为table合并合数自带的参数
 * columnArr 为合并列数组
 */
export function objectSpanMethod(
  { row, column, rowIndex, columnIndex },
  rowSpanArr,
  columnArr
) {
  // 只合并区域位置
  row
  column
  //   console.log(row, column)
  if (columnArr.some((m) => m == columnIndex)) {
    const _row = rowSpanArr[rowIndex][columnIndex]
    return {
      rowspan: _row, //行
      colspan: 1 //列
    }
  }
}

//#endregion
